import { render, staticRenderFns } from "./ScrollToTopButton.vue?vue&type=template&id=19835387&scoped=true&"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js&"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToTopButton.vue?vue&type=style&index=0&id=19835387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19835387",
  null
  
)

export default component.exports